@if (release()) {
  <div class="side-by-side">
    <div class="suite-column">
      <div class="release-detail-header">
        <h3 id="suiteHeading">Test Suites for {{ release()?.releaseName }}</h3>
      </div>
      @if (authService.isAdminSig() && release()?.suites?.length === 0) {
        <div
          mat-subheader
          (click)="onAddNewSuiteClick()"
          class="suite-subheader add-suite-subheader"
        >
          <mat-icon fontIcon="add_circle" class="material-symbols-outlined add-suite"></mat-icon>
          <span style="font-style: italic">Add New Suite</span>
        </div>
      }
      <mat-list role="list">
        @for (suite of release()?.suites; track suite; let last = $last) {
          <div mat-subheader class="suite-subheader">
            <span>{{ suite.suiteName }}</span>
          </div>
          <mat-selection-list
            #suiteList
            [multiple]="false"
            class="test-plan-item"
            [(ngModel)]="selectedPlanModel"
            [compareWith]="comparePlanById"
            aria-label="Test plans for selected suite"
          >
            @for (testPlan of suite.testPlanSummaries; track trackByTestPlanId($index, testPlan)) {
              <mat-list-option
                [ngClass]="{
                  'is-selected': selectedTestPlan()?.testPlanId === testPlan.testPlanId,
                }"
                [value]="testPlan"
                (click)="selectSuite(testPlan)"
              >
                <span class="test-plan">
                  @if (testPlan.numberOfFailingTests > 0) {
                    <mat-icon fontIcon="cancel" class="material-symbols-outlined fail"></mat-icon>
                  } @else if (
                    testPlan.numberOfPassingTests > 0 &&
                    testPlan.numberOfPassingTests === testPlan.numberOfTests
                  ) {
                    <mat-icon
                      fontIcon="check_circle"
                      class="material-symbols-outlined pass"
                    ></mat-icon>
                  } @else {
                    <div style="margin-left: 20px"></div>
                  }
                  {{ testPlan.testPlanName }}
                </span>
              </mat-list-option>
            }
          </mat-selection-list>
          @if (authService.isAdminSig()) {
            <div
              mat-subheader
              (click)="onAddNewSuiteClick()"
              class="suite-subheader add-suite-subheader"
            >
              <mat-icon
                fontIcon="add_circle"
                class="material-symbols-outlined add-suite"
              ></mat-icon>
              <span style="font-style: italic">Add New Suite</span>
            </div>
          }
        }
      </mat-list>
      @if (isSuitesLoading()) {
        <div class="loading-spinner">
          <mat-spinner></mat-spinner>
        </div>
      }
    </div>
    <div class="test-case-column">
      @if (selectedTestPlan()) {
        <h3>{{ selectedTestPlan()?.testPlanName }}</h3>
      }
      @if (isTestCasesLoading()) {
        <div class="loading-spinner">
          <mat-spinner></mat-spinner>
        </div>
      } @else {
        <mat-selection-list
          class="test-case"
          #testCaseList
          [multiple]="false"
          (selectionChange)="onTestCaseChange($event)"
          aria-label="Test cases for selected suite"
        >
          @for (testCase of testCases(); track testCase) {
            <mat-list-option [value]="testCase">
              <div class="test-case-item">
                <div style="display: flex; align-items: center; gap: 4px">
                  @if (testCase.isPassing === false) {
                    <mat-icon fontIcon="cancel" class="material-symbols-outlined fail"></mat-icon>
                  } @else if (testCase.isPassing === true) {
                    <mat-icon
                      fontIcon="check_circle"
                      class="material-symbols-outlined pass"
                    ></mat-icon>
                  } @else {
                    <div style="margin-left: 20px"></div>
                  }
                  <span>
                    {{ testCase.testCaseName }}
                    <span style="font-weight: 300; font-style: italic">
                      (ID: {{ testCase.testCaseAzureId }})
                    </span>
                  </span>
                </div>
                <mat-icon
                  fontIcon="arrow_forward_ios"
                  class="material-symbols-outlined arrow-icon"
                ></mat-icon>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      }
    </div>
  </div>
}

<!-- Full-screen overlay -->
@if (isLoading()) {
  <div class="loading-overlay">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
